import React from 'react'
import { Link } from 'react-router-dom'
import { IconAlertTriangle } from '@tabler/icons-react'
import queryString from 'query-string'

import { Banner } from '@/components/banners/Banner'

export const InsufficientCallDataBanner = ({ organizationId, playbookCid }) => {
  const uploadCallsUrl = `/upload-calls?${queryString.stringify({ organization_id: organizationId, playbook: playbookCid })}`

  return (
    <Banner warning icon={<IconAlertTriangle />}>
      No calls found for this playbook. <Link to={uploadCallsUrl}>Upload calls</Link> to use
      Balto&apos;s AI prompt generator.
    </Banner>
  )
}
